import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class LogsService {
  private api = environment.apiUrl + 'admin/';

  constructor(private http: HttpClient) {}

  getLogs(filters: any = {}) {

    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get<any>(this.api + 'audit-logs', { params });
  }

  getLog(id: number) {
    return this.http.get<any>(this.api + `audit-logs/${id}`);
  }

}


